<template>
  <div class="a-cert">
    <div class="title">证书查询</div>
    <!-- <div class="t-title">选择组别：</div> -->
    <!-- <a-row :gutter="16" style="margin-bottom: 12px">
      <a-col :span="12">
        <a-select v-model="gid" style="width: 100%" @change="group_change">
          <a-select-option v-for="item in g_list" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :span="12">
        <a-select :disabled="current_group.exist_child != 1" v-model="item_id" style="width: 100%">
          <a-select-option v-for="item in item_list" :key="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-col>
    </a-row> -->
    <div class="t-title">输入{{ sname }}查询：</div>
    <div class="input-area">
      <a-input v-model="idno" :placeholder="`输入${sname}查询`"></a-input>
      <a-button type="primary" style="margin-left: 12px" @click="submit">查询</a-button>
    </div>
    <a-divider></a-divider>
    <img :src="item" v-for="(item, i) in cert_url" :key="i" />
    <div v-if="cert_url" class="desc">长按图片保存</div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      cert_url: '',
      idno: '',
      gid: '',
      g_list: [],
      item_id: '',
      item_list: [],
      current_group: {},
      matchid: this.$route.params.matchid,
      type: this.$route.params.type
    }
  },
  computed: {
    sname() {
      if(this.type == 1) {
        return '参赛号码'
      } else if (this.type == 2) {
        return '企业名称'
      }
      return '证件号码'
    },
  },
  mounted() {
    this.get_group()

    let hfz = document.documentElement.clientWidth / 3.75
    document.documentElement.style.fontSize = (hfz > 100 ? hfz : 100) + 'px'
  },
  methods: {
    submit() {
      const query = {
        matchid: this.matchid,
        // groupid: this.gid,
        // sub_groupid: this.item_id,
        type: 1,
        idno: this.idno,
      }
      this.$api.match.userCertAll(query).then((r) => {
        if (r.status == 200) {
          this.cert_url = r.data.url
        }
      })
    },
    get_item_list() {
      this.$api.match.groupList({
        matchid: this.matchid,
        pid: this.gid,
      }).then((r) => {
        if (r.status == 200) {
          this.item_list = r.data.data
          this.item_id = r.data[0].id
        }
      })
    },
    get_group() {
      this.$api.match.groupList({ matchid: this.matchid })
        .then((r) => {
          if (r.status == 200) {
            this.g_list = r.data.data
            this.current_group = r.data.data[0]
            this.gid = r.data.data[0].id
          }
        })
        .then((r) => {
          this.get_item_list()
        })
    },
    group_change(e) {
      if (this.current_group.exist_child == 1) {
        this.get_item_list()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.a-cert {
  padding: 0 0.15rem;
  .title {
    text-align: center;
    width: 100%;
    padding: 0.1rem 0 0.05rem;
    font-size: 0.2rem;
    font-weight: bold;
  }
  .t-title {
    font-size: 0.14rem;
    color: #999;
    margin: 0.08rem 0;
  }
  .input-area {
    display: flex;
    align-items: center;
  }
  img {
    width: 100%;
    padding-bottom: 20px;
  }
  .desc {
    font-size: 0.14rem;
    color: #999;
    text-align: center;
    margin-top: 0.12rem;
  }
}
</style>
